// react
import { useMemo } from 'react';

import styled from 'styled-components';

// editor
import { Container, Title } from '@/components/atoms';

// components
import { InviteKeyRegistrationForm } from '@/components/molecules';
import { OrganizationInfo } from '@karehero/models';

/**
 * InviteKeyRegistration allows registering via
 */
export const InviteKeyRegistration = ({
  organization,
  onSubmit,
}: InviteKeyRegistrationProps) => {
  const inviteKeyName = useMemo(
    () => organization.inviteKeyName || 'Payroll ID',
    [organization],
  );

  return (
    <Container size='md'>
      <Wrapper>
        <Title>{organization.name} Registration</Title>
        <HelperText>
          Register for a KareHero account with your {inviteKeyName}
        </HelperText>
        <InviteKeyRegistrationForm
          inviteKeyLabel={inviteKeyName}
          isEmailRegistration={organization.isEmailRegistrationEnabled}
          onSubmit={(inviteKey: string, email: string) =>
            onSubmit(organization.id, inviteKey, email)
          }
        />
      </Wrapper>
    </Container>
  );
};

const HelperText = styled.div`
  font: ${(props) => props.theme.typography.body.md.regular};
  color: ${(props) => props.theme.color.neutral[80]};
  margin-bottom: ${(props) => props.theme.spacing[24]};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => props.theme.spacing[64]};
`;

interface InviteKeyRegistrationProps {
  organization: OrganizationInfo;
  onSubmit: (organizationID: string, inviteKey: string, email: string) => void;
}

InviteKeyRegistration.displayName = 'InviteKeyRegistration';

export default InviteKeyRegistration;
